import React, { useEffect } from "react"
import IndexTemplate from "../templates/index-template"
import Layout from "../layout"

const Index = prop => {
  const setStart = prop.setStart
  const props = {
    title: "ジャパンライダーズ検定",
    subTitle: "楽しみながらグッドマナーを学ぼう！",
    enTitle: "JAPAN RIDERS CHALLENGE",
    imageNameSP: "welcomeSP",
    imageNamePC: "welcomePC",
    umeSP: "welcomeUmeSP",
    umePC: "welcomeUmePC",
    buttonName: "検定を始めます！",
    buttonFunc: () => setStart(true),
    desc:
      "バイクは楽しくて、カッコいい乗り物。余裕があって、スマートな運転のできる「グッドマナー」なライダーって素敵ですよね！ライダーのみなさん、ひとりひとりがほんの少し意識するだけで、誰もがマナーアップできるのです！ということで、あなたの「グッドマナー」度がどれくらいなのか、検定形式でチェックしながら、マナーについて楽しく学んでみましょう！",
    notes:
      "本検定内で解説している内容は一般的なマナーに関するもので、ライダーみなさんの行動を強制するものではありません。また、交通状況・道路状況によっては、ここでご紹介する内容の限りではないことをご了承ください。状況に即した、安全運転をお願いいたします。",
  }
  return (
    <Layout>
      <IndexTemplate {...props} />
    </Layout>
  )
}

export default Index
